import { render, staticRenderFns } from "./ProdcutAdd.vue?vue&type=template&id=9977184c&scoped=true&"
import script from "./ProdcutAdd.vue?vue&type=script&lang=js&"
export * from "./ProdcutAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9977184c",
  null
  
)

export default component.exports